import { CustomExpandedPanel } from '@core/components/CustomExpandedPanel';
import { TextLabel } from '@core/components/Inputs';
import DateLabel from '@core/components/Inputs/DateLabel';
import { Competencia } from '@format/DATA';
import { Grid } from '@material-ui/core';
import { formatNossoNumero } from 'app/main/contareceber/contaReceberUtils';
import { getCurrency } from 'app/utils/monetarioUtil';
import React, { useContext, useState } from 'react';
import { AcompanharReguaCobrancaContext } from '../../../AcompanharReguaCobrancaContext';

const FORMA_RECEBIMENTO = {
  BOLETO: 'Boleto',
  CARTAO_CREDITO: 'Cartão de crédito',
  CARTAO_DEBITO: 'Cartão de débito',
  CHEQUE: 'Cheque',
  DINHEIRO: 'Dinheiro',
  TED_DOC: 'TED/DOC',
  PIX: 'Pix',
};

const FORMATAR_ORIGEM_LANCAMENTO = {
  CONTRATO: 'Contratos',
  VENDA: 'Vendas',
  CONTA_RECEBER: 'Contas a receber',
  CONTA_PAGAR: 'Contas a pagar',
};

const DetalhesCobrancaForm = () => {
  const [expanded, setExpanded] = useState('baixa');
  const [detalheCobranca] = useContext(AcompanharReguaCobrancaContext).detalheCobranca;

  const handleExpandedChange = (key, value) => {
    if (value) {
      setExpanded(key);
    } else {
      setExpanded(false);
    }
  };

  const Baixa = ({ values }) => {
    return (
      <Grid container style={{ padding: 16 }} spacing={2}>
        <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
          <DateLabel id="dataRecebimento" label="Data do recebimento" value={values?.dataRecebimento} />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="formaRecebimento"
            label="Forma de recebimento"
            value={FORMA_RECEBIMENTO[values?.formaRecebimento]}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
          <TextLabel id="origemBaixa" label="Origem da baixa" value={FORMATAR_ORIGEM_LANCAMENTO[values?.origemBaixa]} />
        </Grid>

        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel id="juros" label="Juros (R$)" value={getCurrency(values?.juros?.valorBruto)} />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel id="multa" label="Multa (R$)" value={getCurrency(values?.multa?.valorBruto)} />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel id="desconto" label="Desconto (R$)" value={getCurrency(values?.desconto?.valorBruto)} />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel
            id="correcaoMonetaria"
            label="Correção monetária (R$)"
            value={getCurrency(values?.correcaoMonetaria?.valorBruto)}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextLabel id="valorRecebido" label="Valor recebido (R$)" value={getCurrency(values?.valorPago)} />
        </Grid>
      </Grid>
    );
  };

  const Content = () => {
    return (
      <>
        <Grid container style={{ padding: 16 }} spacing={2}>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            <TextLabel id="competencia" label="Mês competência" value={Competencia(detalheCobranca?.mesCompetencia)} />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            <TextLabel
              id="origemLancamento"
              label="Origem do lançamento"
              value={FORMATAR_ORIGEM_LANCAMENTO[detalheCobranca?.origemLancamento]}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <TextLabel id="cliente" label="Cliente" value={detalheCobranca?.cliente?.pessoa?.nome} />
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            <TextLabel
              id="categoria"
              label="Categoria"
              value={`${detalheCobranca?.categorias[0]?.classe?.indice} ${detalheCobranca?.categorias[0]?.classe?.nome}`}
            />
          </Grid>

          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <TextLabel id="valorBruto" label="Valor (R$)" value={getCurrency(detalheCobranca?.valorBruto)} />
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            <DateLabel id="dataVencimento" label="Data do vencimento" value={detalheCobranca?.dataVencimento} />
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            <TextLabel
              id="nossoNumeroAntigo"
              label="Nosso número antigo"
              value={formatNossoNumero(
                detalheCobranca?.nossoNumeroAntigo || detalheCobranca?.receitaCobranca?.nossoNumero
              )}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            <TextLabel id="conta" label="Conta" value={detalheCobranca?.conta?.descricao} />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            <TextLabel
              id="documentoFiscal"
              label="Número do documento fiscal"
              value={detalheCobranca?.documentoFiscal}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <TextLabel id="observacoes" label="Observações" value={detalheCobranca?.observacoes} />
          </Grid>
        </Grid>

        <CustomExpandedPanel
          title="Informações da baixa"
          expanded={expanded === 'baixa'}
          onChange={(_, value) => handleExpandedChange('baixa', value)}
        >
          <Grid container spacing={3}>
            <Baixa values={detalheCobranca?.baixa} />
          </Grid>
        </CustomExpandedPanel>
      </>
    );
  };

  return <Content />;
};

export default DetalhesCobrancaForm;
